import React from 'react'
import { Checkbox, CheckboxProps, Flex, Typography } from 'antd'
import { FieldError } from 'react-hook-form'
import ErrorText from 'src/app/shared/components/common/error-text'
import './index.scss'

const CustomCheckbox: React.FC<
  CheckboxProps & {
    label?: string
    required?: boolean
    error?: FieldError
    containerStyle?: React.CSSProperties
  }
> = (props) => {
  const { label, required, error, style, containerStyle, ...etc } = props

  return (
    <div
      className='custom-checkbox'
      style={{
        flex: 1,
        ...containerStyle,
      }}
    >
      <Flex
        style={{
          gap: 8,
          alignItems: 'center',
        }}
      >
        <Checkbox
          style={{
            marginBottom: error ? 4 : 0,
            ...style,
          }}
          {...etc}
        />
        <Typography.Text
          style={{ textAlign: 'left'}}
          className={`${required ? 'required' : ''} custom-checkbox-label`}
        >
          {label}
        </Typography.Text>
      </Flex>
      {error && <ErrorText>{error.message}</ErrorText>}
    </div>
  )
}

export default CustomCheckbox
